﻿import { action, makeObservable, observable } from "mobx";
import dicomParser from "dicom-parser";
import { DicomTags } from "../network/contracts/DicomDataSet";
import { DicomTag } from "../network/contracts/DicomTag";

export class DicomFileReader {
    @observable
    file: File;

    @observable
    reading = false;

    @observable
    dataSet: dicomParser.DataSet | null = null;

    constructor(file: File) {
        makeObservable(this);
        this.file = file;
    }

    public async readFile(): Promise<void> {
        this.setReading(true);
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = (e) => {
                const arr = new Uint8Array(reader.result as Iterable<number>);

                const headerArray = arr.subarray(128, 132);
                const headerInfo = String.fromCharCode.apply(null, headerArray);

                let dataSet: dicomParser.DataSet | null = null;

                if (headerInfo === "DICM") {
                    try {
                        dataSet = dicomParser.parseDicom(arr);
                    } catch (e) {
                        console.error(e);
                        dataSet = null;
                    }
                }

                this.setDataSet(dataSet);
                this.setReading(false);

                return resolve();
            };
            reader.readAsArrayBuffer(this.file);
        });
    }

    @action
    private setReading(value: boolean) {
        this.reading = value;
    }

    @action
    private setDataSet(dataSet: dicomParser.DataSet | null) {
        this.dataSet = dataSet;
    }

    public getDicomTag(key: DicomTags): DicomTag {
        const tag = key.substring(0, 4) + "," + key.substring(4, 8);
        const name = Object.keys(DicomTags)[Object.values(DicomTags).indexOf(key)];

        let value = "";
        if (this.dataSet) {
            value = this.dataSet.string("x" + key.toLowerCase()) ?? "";
        }

        return new DicomTag(name, tag, value, key);
    }
}
